import { CheckoutContracts } from './checkout-contracts.interface';

export interface CheckoutOffer {
  offerReference: string;
  offerId: string | number;
  contracts: CheckoutContracts[];
}
